import { useMemo } from 'react';
import classNames from './UserStreak.module.scss';
import classes from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { Streak } from '@/school-management/types/response/studentDetails';

import checked from '@/assets/images/checked.png';
import unchecked from '@/assets/images/unchecked.png';

interface UserStreakProps {
  className?: string;
  streak: Streak[];
}

const UserStreak = ({ className, streak }: UserStreakProps) => {
  const { t } = useAdminTranslation();

  const modifiedStreak = useMemo(() => {
    return [...streak].sort((a, b) => a.order - b.order);
  }, [streak]);

  return (
    <div className={classes(classNames.userStreak, className)}>
      <div className={classNames.week}>
        {modifiedStreak.map((streak, index) => (
          <div key={index} className={classNames.day}>
            <img src={streak.eventStatus ? checked : unchecked} alt='day-check' />
            <span>{t(`studentDataModal.days.${streak.day.toLowerCase()}`)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserStreak;
